import PropTypes from '../../../utils/propTypes';
import { row } from './index.module.scss';

export const Row = ({ cells }) => {
  return (
    <tr>
      {cells.map((cell, index) => {
        return (
          <td key={`td-${index}`} className={row} style={{ ...cell.style }}>
            {cell.html || (
              <label
                key={`label-${index}`}
                style={{ cursor: cell.style.cursor, ...cell.textStyle }}
              >
                {' '}
                {cell.value}
              </label>
            )}
          </td>
        );
      })}
    </tr>
  );
};

Row.propTypes = {
  cells: PropTypes.arrayOf(PropTypes.object).isRequired,
};

Row.defaultProps = {
  style: { backgroundColor: '#FFFFFF' },
};
